import axiosRequest from '../constants/axios-request'
import { Part } from '../types/training'

export const getPart = (partId: string | undefined): Promise<Part> =>
  axiosRequest.get(`/part/${partId}`).then((result) => result.data)

export const addPart = (payload: {
  part: Omit<Part, 'questions' | 'id' | 'status' | 'color' | 'text'>
  categoryId: string
}): Promise<number> =>
  axiosRequest
    .post(`/part`, payload)
    .then((result) => result.status)
    .catch((error) => error.response.status)

export const updatePart = (
  partId: string,
  payload: Omit<
    Part,
    | 'questions'
    | 'id'
    | 'status'
    | 'color'
    | 'text'
    | 'quizType'
    | 'title'
    | 'isWhat'
    | 'placement'
  >
): Promise<number> =>
  axiosRequest
    .put(`/part/${partId}`, payload)
    .then((result) => result.status)
    .catch((error) => error.response.status)

export const updateTextPart = (
  partId: string,
  payload: { text: string }
): Promise<number> =>
  axiosRequest
    .put(`/part/${partId}`, payload)
    .then((result) => result.status)
    .catch((error) => error.response.status)

export const deletePart = (partId: string | undefined): Promise<number> =>
  axiosRequest
    .delete(`/admin/part/${partId}`)
    .then((result) => result.status)
    .catch((error) => error.response.status)
